import { render } from "./Delivery.vue?vue&type=template&id=beefb992&scoped=true&ts=true"
import script from "./Delivery.vue?vue&type=script&lang=ts"
export * from "./Delivery.vue?vue&type=script&lang=ts"

import "./Delivery.vue?vue&type=style&index=0&id=beefb992&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beefb992"]])

export default __exports__